import { EventEmitter } from 'events';
import Dispatcher from 'core/Dispatcher';
import Actions from 'constants/Actions';
import CategoryStore from 'stores/CategoryStore';
import CargosStore from 'stores/CargosStore';
import EditingCargoStore from 'stores/EditingCargoStore';
import ParametersStore from 'stores/ParametersStore';
import RouteStore from 'stores/RouteStore';
import UserStore from 'stores/UserStore';
import TmpStore from 'stores/TmpStore';
import InstantBookingStore from 'stores/InstantBookingStore';
import GeoConstant from 'constants/Geo';

const CHANGE_EVENT = 'change';

var _isLoading = false;

/**
 * Booking working mode
 *
 * @type {string}
 * @private
 */
var _mode = 'add';

var _orderId = 0;
var _carrierId = 0;

/**
 * This flag means that order is comming from perevezi.ru.
 * Due to the fact that we are closing perevezi.ru in 2017,
 * this flag will soon not need.
 *
 * @type {number}
 * @private
 */
var _from_perevezi = 0;

/**
 * This flag means that order is comming from b2b merchant
 *
 * @type {number}
 * @private
 */
var _b2b = 0;

/**
 * The flag means that order is comming from yandex offer
 * @type {number}
 * @private
 */
var _ya_click_id = 0;

/**
 *
 * @type {number}
 * @private
 */
var _is_widget = 0;

/**
 *
 * The flag means that app runs in Israel
 * @type {number}
 * @private
 */
var _is_for_israel = 0;

/**
 * Default country for all app
 *
 * @type {number}
 * @private
 */
var _default_country = GeoConstant.DEFAULT_COUNTRY;

function getNormalizedState() {
    var result = {};

    result.category_id = CategoryStore.getNormalizedState();

    if (EditingCargoStore.isEditing()) {
        result.stuff = [EditingCargoStore.getNormalizedState()];
    } else {
        result.stuff = CargosStore.getNormalizedState();
    }

    result.total_weight = CargosStore.getTotalWeight();
    if (!result.total_weight) {
        result.total_weight = 0;
    }

    result.total_volume = CargosStore.getTotalVolume();
    if (!result.total_volume) {
        result.total_volume = 0;
    }

    ParametersStore.normalizeState(result);
    RouteStore.normalizeState(result);
    UserStore.normalizeState(result);
    TmpStore.normalizeState(result);
    InstantBookingStore.normalizeState(result, true);

    if (EditingCargoStore.isStuffTankmenValidationOn()) {
        result.stuff_tankmen_validation = 1;
    }

    if (_carrierId > 0) {
        result.carrier_id = _carrierId;
    }

    if (_from_perevezi === 1) {
        result.from_perevezi = 1;
    }

    if (_b2b === 1) {
        result.b2b = 1;
    }

    if (_ya_click_id) {
        result.ya_click_id = _ya_click_id;
    }

    return result;
}

function denormalizeState(normalizedState) {
    CategoryStore.denormalizeState(normalizedState);
    CargosStore.denormalizeState(normalizedState);
    ParametersStore.denormalizeState(normalizedState);
    RouteStore.denormalizeState(normalizedState);
    UserStore.denormalizeState(normalizedState);
    TmpStore.denormalizeState(normalizedState);
    InstantBookingStore.denormalizeState(normalizedState);
}

function setMode(mode) {
    _mode = mode;
}

function setOrderId(orderId) {
    _orderId = orderId;
}

function setCarrierId(carrierId) {
    _carrierId = carrierId;
}

function setPereveziModeOn() {
    _from_perevezi = 1;
}

function setB2B() {
    _b2b = 1;
}

function setWidgetModeOn() {
    _is_widget = 1;
}

function setClickId(clickId) {
    _ya_click_id = clickId;
}

function setIsraelModeOn() {
    _is_for_israel = 1;
}

function setDefaultCountry(countryId) {
    _default_country = countryId;
}

class GeneralStore extends EventEmitter {

    isLoading() {
        return _isLoading;
    }

    isEditMode() {
        return _mode === 'edit';
    }

    isAddMode() {
        return _mode === 'add';
    }

    isWidgetMode() {
        return _is_widget === 1;
    }

    isIsraelModeOn() {
        return _is_for_israel === 1;
    }

    getDefaultCountryId() {
        return _default_country;
    }

    getNormalizedState() {
        return getNormalizedState();
    }

    getOrderId() {
        return _orderId;
    }

    getCarrierId() {
        return _carrierId;
    }

    /**
     * @param {function} callback
     */
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }

    /**
     * @param {function} callback
     */
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }

    emitChange() {
        this.emit(CHANGE_EVENT);
    }

    dispatchToken = Dispatcher.register((action) => {
        const { payload } = action;

        switch (action.type) {
            case Actions.SHOW_LOADING_OVERLAY:
                _isLoading = true;
                break;

            case Actions.HIDE_LOADING_OVERLAY:
                _isLoading = false;
                break;

            case Actions.DENORMALIZE_STATE:
                denormalizeState(payload.state);
                break;

            case Actions.SET_MODE:
                setMode(payload.mode);
                break;

            case Actions.SET_ORDER_ID:
                setOrderId(payload.orderId);
                break;

            case Actions.SET_CARRIER_ID:
                setCarrierId(payload.carrierId);
                break;

            case Actions.SET_PEREVEZI_MODE_ON:
                setPereveziModeOn();
                break;

            case Actions.SET_B2B:
                setB2B();
                break;

            case Actions.SET_WIDGET_MODE_ON:
                setWidgetModeOn();
                break;

            case Actions.SET_CLICKID:
                setClickId(payload.clickId);
                break;

            case Actions.SET_ISRAEL_MODE_ON:
                setIsraelModeOn();
                break;

            case Actions.SET_DEFAULT_COUNTRY:
                setDefaultCountry(payload.countryId);
                break;

            default:
                return;
        }

        this.emitChange();
    })

}

export default new GeneralStore();



// WEBPACK FOOTER //
// ./client/stores/GeneralStore.js